import _ from 'lodash';

import {
  QueryJiraTicketsFilterInput,
  useJiraTicketsTabLazyQuery
} from 'generated/graphql';

import { listQueryUtil } from 'iron-forge-react-modules';
import * as types from './types';
import { DateTime } from 'luxon';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



export interface ITicket {
  id: string;
  createdAt: DateTime;
  key: string;
  title: string;
  description: string;
  context: string;
  labels: string;
}

export interface IData {
  tickets: ITicket[];
}

export function useQuery() {
  const {
    fnQuery,
    queryTuple,
    fnQueryPage,
    pageInfo,
    filterState,
    gqlFilter,
    gqlSort
  } = useListQuery({
    useLazyQuery: useJiraTicketsTabLazyQuery,

    genFilter2GqlFilter: () => __filter2GqlFilter,
    defaultFilterArgs: {},
    clientColumn2GqlSortField: {
      key: 'key',
      createdAt: 'createdAt',
      title: 'title'
    },
    initQuerySort: {
      columnId: 'createdAt',
      direction: 'descending'
    },
    gqlResultData2GqlPageInfo: gqlResultData =>
      gqlResultData?.jiraTickets.pageInfo,

    gqlResultData2TupleData: (gqlTuple): IData => {
      return {
        tickets: _.map(gqlTuple.data?.jiraTickets.nodes, (ticket): ITicket => ({
          id: ticket.id,
          createdAt: DateTime.fromISO(ticket.createdAt),
          key: ticket.key,
          title: ticket.title,
          context: JSON.stringify(ticket.context, null, 2),
          description: ticket.description,
          labels: _.join(ticket.labels, ', ')
        }))

      };
    }
  });


  return {
    fnQuery,
    queryTuple: {
      ...queryTuple,
      loading: queryTuple.loading
    },
    fnQueryPage,
    pageInfo,
    filterState,
    gqlFilter,
    gqlSort
  };
}



function __filter2GqlFilter(filter?: types.IFormState): QueryJiraTicketsFilterInput {
  return {
    omniFreeText: filter?.omniFreeText,
    after: filter?.after ? DateTime.fromJSDate(filter.after).toISO() : undefined,
    before: filter?.before ? DateTime.fromJSDate(filter.before).toISO() : undefined
  };
}
